export default __webpack_public_path__ + "static/media/h100-7.4bdd30b4.png";